import { render, staticRenderFns } from "./DocManage.vue?vue&type=template&id=ab7874f6&scoped=true&"
import script from "./DocManage.vue?vue&type=script&lang=js&"
export * from "./DocManage.vue?vue&type=script&lang=js&"
import style0 from "./DocManage.vue?vue&type=style&index=0&id=ab7874f6&scoped=true&lang=css&"
import style1 from "./DocManage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7874f6",
  null
  
)

export default component.exports